import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useUnarchiveConversation = () => {
  const { unarchiveConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: IDObject) => {
      const { data } = await conversation.unarchive(payload.id);

      return data;
    },
    onSuccess: (conversation) => {
      unarchiveConversation(conversation.id);
    },
  });

  return mutation;
};
